import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import PlaceholderImage from 'components/PlaceholderImage'

const ChecklistItem = ({
  id,
  title,
  description,
  imageUrl,
  imageType,
  imageAlt,
  disabled,
  onClick,
}) => {
  return (
    <div className="checklist-item">
      <div className="checklist-item-title">
        <FormControlLabel
          control={
            <Checkbox
              // checked={state.checkedB}
              onChange={e => onClick(e.target.checked, id, title)}
              name="checkedB"
              color="primary"
            />
          }
          label={title}
        />
      </div>

      <div className={`checklist-image-copy checklist-image-copy-${imageType}`}>
        {imageUrl && (
          <div className="checklist-image">
            <PlaceholderImage
              src={imageUrl}
              height={400}
              width={600}
              className={imageType}
              alt={imageAlt}
            />
          </div>
        )}
        {description && (
          <div
            className="checklist-image-desc"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </div>
  )
}

export default ChecklistItem
